import axios from 'axios';
import {clarify} from "@/utils/clear";

class DuesApi {
    constructor() {
        this.endpoint = process.env.VUE_APP_BASE_API;
    }


    list(body) {
        const params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/dues`, {params}).then(response=>response.data);
    }

    get(duesId) {
        return axios.get(`${this.endpoint}/dues/${duesId}`, {}).then(response=>response.data);
    }

    save(dues) {
        return axios.post(`${this.endpoint}/dues/save`, dues).then(response=>response.data);
    }

    delete(duesId) {
        return axios.delete(`${this.endpoint}/dues/delete/${duesId}`, {}).then(response=>response.data);
    }
    recover(duesId) {
        return axios.put(`${this.endpoint}/dues/recover/${duesId}`, {}).then(response=>response.data);
    }

    histories(duesId) {
        return axios.get(`${this.endpoint}/dues/${duesId}/histories`, {}).then(response=>response.data);
    }

}


export default new DuesApi();
